// Quote Builder Constants

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CLIENT_TYPES = {
  Retail: 0.45,
  Business: 0.35,
  Promo: 0.25,
};

// PRINT_METHODS is defined in the single source of truth (printMethods.js) and
// re-exported here so existing `import { PRINT_METHODS } from ".../constants"`
// callers keep working without drifting from the Pricing Tables screen.
export { PRINT_METHODS, PRINT_METHOD_DEFINITIONS, METHOD_BY_TABLE } from "./printMethods";

// Screen Print Pro sheet size tiers (Velflex 2026)
export const SHEET_SIZES = [
  { value: "Standard", label: "Standard (280×240mm)" },
  { value: "Maxi", label: "Maxi (310×280mm)" },
  { value: "Mega", label: "Mega (360×320mm)" },
];

// Business size tiers with area descriptions (for business quotes)
export const SIZE_TIERS = [
  "XS (Up to 36cm² - Cap)",
  "S (Up to 100cm² - Pocket)",
  "M (Up to 315cm² - Standard Chest)",
  "L (Up to 625cm² - Large Chest)",
  "XL (Up to 1250cm² - Back)",
];

// Clean retail size tiers (for retail quotes)
// No price hints - Quote Summary is the source of truth for pricing
export const RETAIL_SIZE_TIERS = [
  { value: "XS", label: "XS - Extra Small" },
  { value: "S", label: "S - Small" },
  { value: "M", label: "M - Medium" },
  { value: "L", label: "L - Large" },
  { value: "XL", label: "XL - Extra Large" },
];

export const BLOCKERS = ["Standard", "Dye", "Sublimation", "Softshell"];
export const PRINT_COLOURS = ["White", "Black", "Other"];

// Screen Print Pro print types (simplified UI)
export const SCREEN_PRINT_TYPES = [
  { value: "White (1 Colour)", screens: 1, printColour: "White" },
  { value: "Black (1 Colour)", screens: 1, printColour: "Black" },
  { value: "1 Colour", screens: 1, printColour: "Other" },
  { value: "2 Colours", screens: 2, printColour: "Other" },
  { value: "3 Colours", screens: 3, printColour: "Other" },
  { value: "4 Colours", screens: 4, printColour: "Other" },
];

export const SUPPLIER_SHIPPING_TYPES = [
  "Apparel Shipping",
  "Print Shipping",
  "Outsource Shipping",
];

export const JOB_STATUSES = [
  "Draft",
  "Sent",
  "Approved",
  "In Production",
  "Complete",
  "Cancelled",
];

export const STATUS_COLORS = {
  Draft: "bg-slate-100 text-slate-700 border-slate-300",
  Sent: "bg-purple-100 text-purple-700 border-purple-300",
  Approved: "bg-green-100 text-green-700 border-green-300",
  "Changes Requested": "bg-amber-100 text-amber-700 border-amber-300",
  "In Production": "bg-blue-100 text-blue-700 border-blue-300",
  Complete: "bg-emerald-100 text-emerald-700 border-emerald-300",
  Cancelled: "bg-red-100 text-red-700 border-red-300",
};

export const formatCurrency = (value) => {
  // Handle undefined, null, NaN values gracefully
  if (value === undefined || value === null || isNaN(value)) {
    return "$0.00";
  }
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
  }).format(value);
};

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const getInitialJobState = (today) => ({
  job_name: "",
  quote_date: today,
  deadline: "",
  status: "Draft",
  internal_notes: "",
  customer_id: null,
  client: {
    business_name: "",
    contact_name: "",
    name: "",
    email: "",
    phone: "",
    website: "",
    physical_address: "",
    postal_address: "",
  },
  client_type: "Business",
  margin_percent: 0.35,
  design_required: false,
  design_fee: 0,
  apply_margin_to_design: false,
  apply_small_order_fee: true, // Default ON - can be toggled to waive small order fee
  garments: [],
  artwork_groups: [],
  supplier_shipping: [],
  shipping: 0,
  misc_costs: 0,
  // Quantity Break Mode fields
  is_quantity_break: false,
  quantity_break_settings: [], // [{quantity, margin_percent, shipping}]
});
